import { render, staticRenderFns } from "./Jurnal.vue?vue&type=template&id=44230850&"
import script from "./Jurnal.vue?vue&type=script&lang=js&"
export * from "./Jurnal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports